module.exports = __webpack_public_path__ + "img/ideation-04-keyfeature-ico-02-grey.e40ff3f8.svg";